'use client';
import * as React from "react";
const AccordionHeaderContext = React.createContext(undefined);
const accordionHeaderContextDefaultValue = {
    open: false,
    disabled: false,
    size: 'medium',
    expandIconPosition: 'start'
};
export const { Provider: AccordionHeaderProvider } = AccordionHeaderContext;
export const useAccordionHeaderContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = React.useContext(AccordionHeaderContext)) !== null && _React_useContext !== void 0 ? _React_useContext : accordionHeaderContextDefaultValue;
};
